import { useQuery } from 'react-query'
import request from '../request'

export const useGetDealershipsByOrganizationId = (
  organizationId: number,
  options = {},
) => {
  return useQuery(
    ['organization_id', organizationId, 'dealerships'],
    () =>
      request<{ data: any }>({
        url: `/agencies/${organizationId}/dealerships`,
        method: 'GET',
      }).then((res) => res.data),
    {
      ...options,
    },
  )
}
